import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { get } from 'lodash';

import config from './config';
import { logMsalEvent } from './msal-event-logger';
import { acquireIdTokenWithInstance } from './msal-token';

export const msalInstance = await PublicClientApplication.createPublicClientApplication(config.AUTH.msal);

export const getCurrentAccount = () => {
  return msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0] || null;
};

msalInstance.addEventCallback((e) => {
  const eventAccount = get(e, 'payload.account');

  if (
    [EventType.LOGIN_SUCCESS, EventType.ACQUIRE_TOKEN_SUCCESS, EventType.SSO_SILENT_SUCCESS].includes(e.eventType)
    && eventAccount
  ) {
    msalInstance.setActiveAccount(eventAccount);
  }

  if (e.eventType === EventType.LOGOUT_SUCCESS) {
    msalInstance.setActiveAccount(null);
  }

  logMsalEvent(e);
});

// Delegates to msal-token.js's instance-based implementation (kept in a separate module with no
// top-level await, so it stays parseable by Jest 27 - see that module's own comment). Also handles
// forcing a refresh of a cached-but-near-expiry ID token, and forceRefresh passed through explicitly
// by a 401 retry (see services/secureLubaApi.js, services/mixedAuthLubaApi.js, services/auth-fetch.js).
export const acquireAccessToken = (opts) => acquireIdTokenWithInstance(msalInstance, opts);
